import { create } from "zustand";
import { api } from "../api";
import type { UserSummary } from "@shared/types";

interface UserState {
  user: UserSummary | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  verifyToken: (token: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  loading: true,
  error: null,
  refresh: async () => {
    set({ loading: true, error: null });
    try {
      const { user } = await api.me();
      set({ user, loading: false });
    } catch (e) {
      set({ user: null, loading: false, error: e instanceof Error ? e.message : "error" });
    }
  },
  verifyToken: async (token) => {
    set({ loading: true, error: null });
    try {
      const { user } = await api.verifyToken(token);
      set({ user, loading: false });
    } catch (e) {
      set({ loading: false, error: e instanceof Error ? e.message : "error" });
      throw e;
    }
  },
  logout: async () => {
    await api.logout();
    const { user } = await api.me();
    set({ user });
  },
}));
